import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Plaid from 'components/Plaid';
import { BackButton } from 'components/Button';
import { backAction, nextAction } from 'actions/workflow';
import { FormRow } from 'components/Form';
import GeneralError from 'components/GeneralError';
import useWorkflowGuard from 'hooks/useWorkflowGuard';

const InstantVerification = ({
  navigate,
  dispatch,
  searchParams,
}) => {
  useWorkflowGuard(searchParams, navigate);
  const key = searchParams.get('key');
  const [generalError, setGeneralError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  const handleFail = (err) => {
    setGeneralError(get(err, 'data.failure.errors.0'));
    setIsLoading(false);
  }

  const handlePlaidSuccess = (publicToken, metadata, sessionId) => {
    dispatch(nextAction({
      key,
      data: {
        isPlaidComplete: true,
        plaidSessionId: sessionId,
        publicToken: {
          linkSessionId: get(metadata, 'link_session_id'),
          publicToken,
          accounts: (get(metadata, 'accounts') || []).map(acc => ({
            accountId: get(acc, 'id'),
            mask: get(acc, 'mask'),
            name: get(acc, 'name'),
            subtype: get(acc, 'subtype'),
            type: get(acc, 'type'),
          })),
          institution: {
            institutionId: get(metadata, 'institution.institution_id'),
            name: get(metadata, 'institution.name'),
          },
        },
      },
      success: (res) => {
        const nextUrl = get(res, 'data.url');
        if (nextUrl) navigate(nextUrl);
      },
      fail: handleFail,
    }));
  };


  const handlePlaidExit = () => {
    setIsLoading(true);

    dispatch(backAction({
      key,
      success: (res) => {
        navigate(get(res, 'data.url'));
        setIsLoading(false);
      },
      fail: handleFail,
    }))
  };

  return (
    <div className="text-center">
      <Plaid
        onPlaidSuccess={handlePlaidSuccess}
        onPlaidExit={handlePlaidExit}
      />

      <GeneralError error={generalError} className="mt-4" />

      <FormRow className="w-full mt-4">
        <BackButton
          className="flex-1"
          onBeforeBack={() => setGeneralError(null)}
          onFail={handleFail}
          isDisabled={isLoading}
        />
      </FormRow>
    </div>
  );
;}

InstantVerification.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired
};

export default InstantVerification;
